import { render, staticRenderFns } from "./EcoActions.vue?vue&type=template&id=45684ba2"
import script from "./EcoActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./EcoActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports